export const DEFAULT_PERSONA = { type: "corporate", label: "employee", label_plural: "employees", cta: "Refer an Employee", cta_again: "Refer Another Employee", who: "an employee" };
export const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");
